export const renderTemplate = (template: string, data: any): any => {
  const reg = /\{(\w+)\}/
  if (reg.test(template)) {
    const regArr = reg.exec(template)
    const name = regArr ? regArr[1] : ''
    const key = data[name]
    template = template.replace(reg, key)
    return renderTemplate(template, data)
  }
  return template
}

export const getObjectValue = (
  object: any,
  path: any,
  defaultValue: any
): any => {
  const arr: string[] = !Array.isArray(path)
    ? (path as any).replace(/\[/g, '.').replace(/\]/g, '').split('.')
    : (path as any[])

  return arr.reduce((o: any, k: any) => (o || {})[k], object) || defaultValue
}
